// Added by Sejune Oh on 2020-03-02
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import React, { FC, forwardRef } from 'react';
import {
    Card as MaterialUICard,
    CardProps as MaterialUICardProps
} from '@material-ui/core'

interface CardBaseProps { }
export type CardProps = Partial<MaterialUICardProps> & CardBaseProps

export const Card: FC<CardProps> = forwardRef(({ ...props }, ref) => {
    return <MaterialUICard ref={ref} {...props}></MaterialUICard>
})
